import { Banner } from '@optimus-web/core';
import { DateTimeUtils, useDateTimeLocalizationInfo, useTimezone } from '@mews/framework';
import { ReservationLinkResult } from '@mews-commander/data-access';
import { LocalizedTypography, useCalendarService } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { getFormatStructuredDate } from './utils';

export const CreatePaymentPlanDialogIntervalBanner = ({
    reservation: { reservationStartUtc, reservationEndUtc },
}: {
    reservation: ReservationLinkResult;
}) => {
    const timezone = useTimezone();
    const localizationInfo = useDateTimeLocalizationInfo();
    const calendarService = useCalendarService();
    const formatDate = getFormatStructuredDate(calendarService, localizationInfo.dateFormat);

    const startUtcStructured = DateTimeUtils.utcToStructuredDate(reservationStartUtc, timezone);
    const endUtcStructured = DateTimeUtils.utcToStructuredDate(reservationEndUtc, timezone);

    const currentDate = calendarService.getCurrentDate();
    const isFutureReservation = calendarService.isDateGreater(startUtcStructured, currentDate);

    const localizedStartDate = formatDate(startUtcStructured);
    const localizedEndDate = formatDate(endUtcStructured);

    return (
        <Banner
            primaryText={
                <LocalizedTypography
                    textStyle="bodyMedium"
                    textKey={
                        isFutureReservation
                            ? TextKey.CreatePaymentPlanDialogIntervalBannerFutureInfoMessage
                            : TextKey.CreatePaymentPlanDialogIntervalBannerStartedInfoMessage
                    }
                    substitutes={{
                        startDate: localizedStartDate,
                        endDate: localizedEndDate,
                    }}
                    as="div"
                />
            }
            variant="info"
        />
    );
};
